export default {
  1: {
    label: 'Name',
    nested: [
      {
        type: 'text',
        name: 'name-first',
        placeholder: 'First Name',
        validation: {
          required: true,
        },
        icon: 'user',
      },
      {
        type: 'text',
        name: 'name-middle',
        placeholder: 'Middle Name',
        validation: {},
        icon: 'user',
      },
      {
        type: 'text',
        name: 'name-last',
        placeholder: 'Last Name',
        validation: {
          required: true,
        },
        icon: 'user',
      },
      {
        type: 'text',
        name: 'name-suffix',
        placeholder: 'Suffix',
        validation: {},
        icon: 'user',
      },
    ],
  },
  2: {
    type: 'select',
    name: 'medical-credential',
    label: 'Credential',
    options: [
      'MD',
      'DO',
      'DPM',
    ],
    validation: {
      required: true,
    },
  },
  3: {
    type: 'text',
    name: 'medical-license',
    validation: {
      required: true,
    },
    label: 'License Number',
    placeholder: 'Your license number',
    icon: 'stethoscope',
  },
  4: {
    type: 'email',
    name: 'email',
    validation: {
      required: true,
    },
    label: 'Email',
    placeholder: 'Your email',
    icon: 'envelope',
  },
  5: {
    type: 'text',
    name: 'medical-practice',
    validation: {
      required: true,
    },
    label: 'Name of Primary Practice',
    placeholder: 'Your practice\'s name',
    icon: 'building',
  },
  6: {
    type: 'nomination',
  },
};
